<p-inputSwitch [ngModel]="value"
               (ngModelChange)="handleChange($event)"
               (focusout)="handleBlur()"
               [inputId]="inputId"
               [disabled]="disabled"
               [styleClass]="styleClass"
               [ariaLabel]="ariaLabel"
               [ariaLabelledBy]="ariaLabelledBy"
               [aeroTooltip]="aeroTooltip"
               [tooltipDisabled]="tooltipDisabled"></p-inputSwitch>
